/* NOTE */
/* These are custom formats that are not part of the i18n library. */
/* They are used in the project to format dates and times. */
/* Sync them with the project's custom formats in `rails.en.yml`.*/

import { I18n } from 'i18n-js';
import en from 'i18n-js/json/en.json';

const customFormats = {
  en: {
    date: {
      formats: {
        medium: '%b %d, %Y', // "Feb 17, 2025"
        custom1: '%a, %b %d %Y', // "Mon, Feb 17 2025"
      },
    },
    time: {
      formats: {
        medium: '%b %d, %Y %H:%M', // "Feb 17, 2025 13:11"
        compact: '%H:%M', // "13:11"
        custom1: '%a, %b %d %Y %H:%M', // "Mon, Feb 17 2025 13:11"
      },
    },
    datetime: {
      distance_in_words_with_ago: {
        about_x_hours: {
          one: 'about one hour ago',
          other: 'about %{count} hours ago',
        },
        about_x_months: {
          one: 'about one month ago',
          other: 'about %{count} months ago',
        },
        about_x_years: {
          one: 'about 1 year ago',
          other: 'about %{count} years ago',
        },
        almost_x_years: {
          one: 'almost one year ago',
          other: 'almost %{count} years ago',
        },
        half_a_minute: 'half a minute ago',
        less_than_x_minutes: {
          one: 'less than a minute ago',
          other: 'less than %{count} minutes ago',
        },
        less_than_x_seconds: {
          one: 'less than a second ago',
          other: 'less than %{count} seconds ago',
        },
        over_x_years: {
          one: 'more than one year ago',
          other: 'more than %{count} years ago',
        },
        x_days: {
          one: 'one day ago',
          other: '%{count} days ago',
        },
        x_minutes: {
          one: 'one minute ago',
          other: '%{count} minutes ago',
        },
        x_months: {
          one: 'one month ago',
          other: '%{count} months ago',
        },
        x_seconds: {
          one: 'one second ago',
          other: '%{count} seconds ago',
        },
        x_years: {
          one: 'one year ago',
          other: '%{count} years ago',
        },
      },
    },
  },
};
const i18n = new I18n();

i18n.store(en);
i18n.store(customFormats);

export default i18n;
